import styled, { css, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`

export const AlertWrapper = styled.div`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  max-width: 300px;
  padding: 10px 15px;

  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 10;

  border-radius: 8px;
  font-size: 14px;
  color: white;
  animation: ${fadeIn} 0.3s ease;

  ${({ type, theme }) => {
    const colors = {
      success: theme.colors.success,
      warning: theme.colors.warning,
      error: theme.colors.red,
      info: theme.colors.brandGray,
    }
    return css`
      background-color: ${colors[type] || theme.colors.primary};
    `
  }}
`

export const Message = styled.div`
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: ${({ theme }) => `${theme.colors.primary}`};
`

export const Action = styled.div`
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    opacity: 0.7;
  }
`
